<script>
import { VTextarea } from 'vuetify/lib'
import inputMixin from '@/vuetify-mixins/input-mixin'

export default {
	extends: VTextarea,
	mixins: [inputMixin],
}
</script>
